import React from 'react';

import { Column } from 'components/Layout/Grid';
import Text from 'components/Text';

import warningImg from 'img/question-img.svg';

import { SchedulingWarningProps } from './interface';
import { EnumErrorCodeRequest } from 'pages/DeliveryScheduling/interface';

import { TextWarning } from './styles';

export const SchedulingWarning: React.FC<SchedulingWarningProps> = (props) => {

  const {
    msgWarning = "",
    errorRequest = ""
  } = props;

  const conditionShowTitle = () => {
    if (errorRequest && errorRequest === EnumErrorCodeRequest.INVALID_TICKET)
      return "Agendamento já realizado";

    return "Não foi possível concluir o agendamento";
  };

  return (
    <Column className="bg-white w-100 flex-1 h-100 align-center justify-center">
      <img src={warningImg} alt="" />
      <Text className="color-blue-gray font-bold m-3" size={18}>
        {conditionShowTitle()}
      </Text>

      <TextWarning className="color-blue-gray">
        {msgWarning}
      </TextWarning>
    </Column>
  );
};